import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/core";
import React, { useState } from "react";
import styled from "styled-components";
import InnerContentWrapper from "../styles/InnerContentWrapper";
import ChangePassword from "./ChangePassword";
import UpdateUser from "./UpdateUser";

const AccountComponentWrapper = styled.div`
  .grid {
    display: grid;
    grid-template-columns: 1fr 2px 1fr;
    column-gap: 8%;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      display: block;

      .spacer {
        display: none;
      }
      .changePassword {
        margin-top: 3rem;
      }
    }
  }
  .spacer {
    width: 2px;
    height: 100%;
    background: transparent;
  }
  .componentWrapper {
    width: 100%;
    h2 {
      font-size: 30px;
      margin-bottom: 2rem;
    }
    .email {
      margin: 10px 0 18px;
      padding: 8px;
      font-size: 18px;
      font-family: "Roboto", sans-serif;
    }
    button {
      display: inline-block;
      padding: 20px;
      font-size: 20px;
      color: white;
      border-radius: 4px;
      background: ${(props) => props.theme.primaryBlue};
      margin-top: 2rem;
      text-align: center;
    }
  }
`;

const AccountComponent = (props) => {
  const [modalMessage, setmodalMessage] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const closeModal = () => {
    onClose();
    props.refetchUser();
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={closeModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <div style={{ padding: "60px 20px 20px" }}>{modalMessage}</div>
          </ModalBody>

          <ModalFooter>
            <Button onClick={closeModal}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <InnerContentWrapper>
        <AccountComponentWrapper>
          <div className="grid">
            <UpdateUser
              userData={props.userData}
              onOpen={onOpen}
              setmodalMessage={setmodalMessage}
              refetchUser={props.refetchUser}
            />
            <div className="spacer"></div>
            <ChangePassword
              userData={props.userData}
              onOpen={onOpen}
              setmodalMessage={setmodalMessage}
              refetchUser={props.refetchUser}
            />
          </div>
        </AccountComponentWrapper>
      </InnerContentWrapper>
    </>
  );
};

export default AccountComponent;
